// extracted by mini-css-extract-plugin
module.exports = {"section":"_35Y1DcAyB7","header":"_2dvocfe6mp","header-content":"_1dQDLT_r8X","headerContent":"_1dQDLT_r8X","title":"n8gHK1-yUe","description":"YMx-0kHEfD","expand-button":"_1dkivzUbKW","expandButton":"_1dkivzUbKW","content":"_17Z3ShDC2E"};
    if(module.hot) {
      // 1614934718552
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  